import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import "./question.css";

const Question = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40">FAQs</h2>
      <Row className="p-4">
        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="0"
              onClick={() => handleToggle("0")}
            >
              <Accordion.Header as="h3" className="red-header">
              What treatments do you offer at Regent Dental?
              </Accordion.Header>
              <Accordion.Body>
              We provide a full range of dental services, including general check-ups, hygiene appointments, cosmetic dentistry, dental implants, orthodontics (like Invisalign(R)), and facial aesthetics. Your smile is in safe hands with us!
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header as="h3" className="red-header">
              How do I register as a new patient?
              </Accordion.Header>
              <Accordion.Body>
              Registering with Regent Dental is easy. Simply give us a call or fill in our online contact form, and our friendly team will be delighted to arrange your first appointment.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header as="h3" className="red-header">
              Do you offer emergency appointments?
              </Accordion.Header>
              <Accordion.Body>
              Yes, we do. If you’re experiencing dental pain or have had an accident, please contact us as soon as possible and we’ll do our best to see you the same day.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header as="h3" className="red-header">
              Are you accepting NHS patients?
              </Accordion.Header>
              <Accordion.Body>
              Currently, we are welcoming new private patients. If you’re interested in joining our practice, we’ll happily talk you through our affordable private care options.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="9"
              onClick={() => handleToggle("9")}
            >
              <Accordion.Header as="h3" className="red-header">
              How do I book an appointment?
              </Accordion.Header>
              <Accordion.Body>
              Booking is simple – you can call us, email us, or fill in our online booking form. Our lovely reception team will help find a time that suits you best.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header as="h3" className="red-header">
              How much do treatments cost?
              </Accordion.Header>
              <Accordion.Body>
              We believe in clear, upfront pricing. You can find a full list of our treatment fees on our website, and we’re always happy to provide a tailored estimate after your consultation.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="5"
              onClick={() => handleToggle("5")}
            >
              <Accordion.Header as="h3" className="red-header">
              Do you offer payment plans?
              </Accordion.Header>
              <Accordion.Body>
              Yes, we offer flexible finance options to help you spread the cost of your treatment, making it easier to achieve the smile you’ve always wanted.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="6"
              onClick={() => handleToggle("6")}
            >
              <Accordion.Header as="h3" className="red-header">
              I'm a nervous patient – can you help?
              </Accordion.Header>
              <Accordion.Body>
              Absolutely. Our team specialises in gentle, compassionate care. We’ll take the time to understand your concerns and make your visits as comfortable and stress-free as possible. We also offer sedation if it's felt appropriate.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="7"
              onClick={() => handleToggle("7")}
            >
              <Accordion.Header as="h3" className="red-header">
              How often should I visit the dentist?
              </Accordion.Header>
              <Accordion.Body>
              We generally recommend a dental check-up every six months, but we’ll always advise you personally based on your individual needs.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="8"
              onClick={() => handleToggle("8")}
            >
              <Accordion.Header as="h3" className="red-header">
              Where is Regent Dental located?
              </Accordion.Header>
              <Accordion.Body>
              We’re conveniently located in Ilkley just off The Grove, with easy parking and excellent transport links nearby. You can find our full address and directions on our Contact page.
              </Accordion.Body>
            </Accordion.Item>
            
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default Question;
